import { useCallback, useState } from "react";

// State that snaps back to `initial` whenever `resetKey` changes, in the same
// render. Unlike resetting in a useEffect, queries keyed on this value never
// see the stale value first, so they fetch once instead of twice.
export default function useResettableState<T>(initial: T, resetKey: string) {
  const [state, setState] = useState({ key: resetKey, value: initial });
  const value = state.key === resetKey ? state.value : initial;
  const setValue = useCallback(
    (next: T) => setState({ key: resetKey, value: next }),
    [resetKey],
  );
  return [value, setValue] as const;
}
